import { async } from 'q';
import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';
const baseUrl = new APISettings().getApiURL();

class TitleApi<Title> extends BaseAPI {
  // constructor() {}

  public getTitles: () => Promise<Title[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/title`)).data.output;
  };

  public getTitleByAgencyId: (id: number) => Promise<Title[]> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/title/GetByAgencyId/${id}`)).data.output;
  };

  public updateTitle: (title: Title) => Promise<Title> = async (title: Title) => {
    return await BaseAPI.axios.post(`${baseUrl}/title`, title);
  };

  public createTitle: (title: Title) => Promise<Title> = async (title: Title) => {
    return await BaseAPI.axios.put(`${baseUrl}/title`, title);
  };

  public getTitleById: (id: number) => Promise<Title> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/title/${id}`)).data.output;
  };

  public titlePdfExists: (titleId: number) => Promise<boolean> = async (titleId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/title/${titleId}/pdfExists`)).data.output;
  };

  public createTitlePdf: (titleId: number) => Promise<boolean> = async (titleId: number) => {
    return (await BaseAPI.axios.post(`${baseUrl}/title/${titleId}/createPdf`)).data.output;
  };

  public getFiltered: (agencyId: number) => Promise<Title[]> = async (agencyId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/title/filtered/${agencyId}`)).data.output;
  };

  public recreatePdf: (id: number) => Promise<string> = async (id: number) => {
    let blobName = (await BaseAPI.axios.get(`${baseUrl}/title/${id}/recreatePdf`)).data.message;
    return blobName;
  };
}

export const titleAPI = new TitleApi();
